import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { DealerPortalModule as Module } from '@jfw/types';
import { ModuleAccessService } from '../../services/module-access/module-access.service';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { ShippingInfoComponent } from './shipping-info/shipping-info.component';

@Component({
  selector: 'app-account-info-dashboard',
  templateUrl: './account-info-dashboard.component.html',
  styleUrls: ['./account-info-dashboard.component.scss'],
  imports: [
    MatDividerModule,
    MatButtonModule,
    ShippingInfoComponent,
    AnnouncementsComponent,
  ],
})
export class AccountInfoDashboardComponent {
  private readonly moduleAccessService = inject(ModuleAccessService);

  // Independent of the parent dashboard's own outer gate -- each widget in
  // this shell decides its own visibility rather than inheriting the
  // parent's, since Announcements (granted to every newSite dealer) and
  // Shipping Info (DeliveryInfo, wholesale-only) can now diverge.
  protected readonly displayShippingInfo = toSignal(
    this.moduleAccessService.canAccessModule(Module.DeliveryInfo),
  );

  protected readonly displayAnnouncements = toSignal(
    this.moduleAccessService.canAccessModule(Module.Announcements),
  );
}
